import { isInContentFrame } from "Helper/aemHelper";
import { hasClass } from "@kluntje/js-utils/lib/dom-helpers";
import { getCookie } from "Helper/storageHelper";

/**
 * Returns true if in Edit|Scaffolding|Developer|Design modes, false otherwise
 * @returns {boolean}
 */
export const isEdit = (): boolean => {
  const htmlEl = window.self.document.querySelector("html") as HTMLElement;
  const EDIT_CLASS = "aem-AuthorLayer-Edit";
  const MODE_COOKIE = "wcmmode";
  const EDIT = "edit";

  return isInContentFrame() && (hasClass(htmlEl, EDIT_CLASS) || getCookie(MODE_COOKIE) === EDIT);
};
